import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import ensureGoogleAnalytics from '../ensureGoogleAnalytics';
export default function sendImpressions(_x, _x2, _x3) {
  return _sendImpressions.apply(this, arguments);
}
function _sendImpressions() {
  _sendImpressions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, data, options) {
    var history;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          history = _ref.history;
          _context.next = 3;
          return ensureGoogleAnalytics(options, function (dataLayer) {
            dataLayer.push(_extends({
              event: 'analytics_event',
              eventAction: 'impression',
              eventNonInteractive: true,
              eventData: {}
            }, data));
          }, {
            history: history
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendImpressions.apply(this, arguments);
}